import React  from 'react';
import ProfessionalCovenants from './ProfessionalCovenants';
import ProfessionalName from './ProfessionalName';
import ProfessionalSpecialities from './ProfessionalSpecialities';

const InformationProcedimiento = ({ professional }) => {

    return (
        <>
            <ProfessionalName nameProfessional={professional.agpNombre} />
            <div style={{ marginBottom: '16px' }}>
                <ProfessionalSpecialities specialities={professional.aseDescrip} />
            </div>
            <ProfessionalCovenants covenants={professional.convenios} />
        </>
    )
}

export default InformationProcedimiento